<template>
  <v-card class="elevation-5">
    <v-card-title>
      <v-row class="v-label font-weight-bold textcolor--text">
        <v-col cols="10" class="text-left">
          {{ item.header }}
        </v-col>
        <v-col cols="1" class="text-right">
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list>
        <v-list-item
            v-for="(link, index) in links"
            :key="index"
            v-test="{ 'list-item': link.id }"
            link
            v-bind="link.route
              ? { to: link.route }
              : {}"
            v-on="link.method
              ? { click: link.method }
              : {}">
          <v-list-item-content>
            <v-row>
              <v-col class="text-left" cols="10">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-list-item-title v-on="on" v-text="link.name" />
                  </template>
                  <span>
                    {{ link.name }}
                  </span>
                </v-tooltip>
              </v-col>
              <v-col class="text-right mr-3 ml-1" sm="1">
                <v-avatar v-if="link.count" color="primary" size="25">
                  <span v-test="{ count: link.count }" class="textwithbackground--text">
                    {{ link.count }}
                  </span>
                </v-avatar>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<style scoped>
::v-deep .v-list-item__title {
  white-space: pre-wrap !important;
}
</style>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    computed: {
      links () {
        return this.item.links.filter(l => l.show)
      }
    }
  }
</script>
